import { render, staticRenderFns } from "./page01.vue?vue&type=template&id=2f8199c4&scoped=true&"
import script from "./page01.vue?vue&type=script&lang=js&"
export * from "./page01.vue?vue&type=script&lang=js&"
import style0 from "./page01.vue?vue&type=style&index=0&id=2f8199c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8199c4",
  null
  
)

export default component.exports